// extracted by mini-css-extract-plugin
export default {"tasksActions":"styles_tasksActions__wwRTR","multiSelectBtn":"styles_multiSelectBtn__Cx35g","searchBtn":"styles_searchBtn__orM3n"};